import React from "react";
import { useSpring, animated } from "react-spring";

export const Features = (props) => {
  return (
    <div id="weekly_updates" className="text-center">
      <div className="container">
        <div className="col-md-10 col-md-offset-1 section-title">
          <h2>Weekly updates</h2>
        </div>
        <div className="row">
          {props.data
            ? props.data.map((d, i) => (
                <div key={`${d.title}-${i}`} className="col-xl-4 col-md-4">
                  <h3>{d.title}</h3>
                  <AnimatedNumber value={Number(d.number)} />
                  <h3>{d.subtitle}</h3>
                </div>
              ))
            : "Loading..."}
        </div>
      </div>
    </div>
  );
};

// AnimatedNumber component using react-spring directly in Features
const AnimatedNumber = ({ value }) => {
  const animatedProps = useSpring({
    from: { number: 0 },
    to: { number: value },
    delay: 200,
    config: { mass: 1, tension: 20, friction: 10 },
  });

  return <animated.h1 style={{ fontSize: 120 }}>{animatedProps.number.interpolate((n) => n.toFixed(0))}</animated.h1>;
};
